import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/jengahills.jpeg'


const _hoisted_1 = { class: "bg-primary-900 text-secondary-300" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" }
const _hoisted_4 = { class: "lg:col-span-1" }
const _hoisted_5 = { class: "space-y-2 text-sm" }
const _hoisted_6 = { class: "space-y-2 text-sm" }
const _hoisted_7 = { class: "border-t border-primary-700 mt-10 pt-8 mb-6" }
const _hoisted_8 = { class: "bg-primary-800 rounded-2xl border border-primary-700 p-6 flex flex-col sm:flex-row items-center justify-between gap-4" }
const _hoisted_9 = { class: "border-t border-primary-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-secondary-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "flex items-center gap-3 mb-4"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Jenga Hills",
                class: "h-10 w-auto rounded"
              }, null, -1),
              _createElementVNode("span", { class: "text-white font-bold text-lg" }, "Jenga Hills", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm leading-relaxed text-secondary-400" }, " Quality construction materials delivered to your site. Building Rwanda, one project at a time. ", -1))
        ]),
        _createElementVNode("div", null, [
          _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-white font-semibold text-sm mb-4 uppercase tracking-wide" }, "Shop", -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/shop",
                class: "hover:text-white transition-colors"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("All Products", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/shop?category=cement-concrete",
                class: "hover:text-white transition-colors"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Cement & Concrete", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/shop?category=steel-iron",
                class: "hover:text-white transition-colors"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Steel & Iron", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/shop?category=roofing",
                class: "hover:text-white transition-colors"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Roofing", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-white font-semibold text-sm mb-4 uppercase tracking-wide" }, "Account", -1)),
          _createElementVNode("ul", _hoisted_6, [
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/profile",
                      class: "hover:text-white transition-colors"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("My Profile", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/orders",
                      class: "hover:text-white transition-colors"
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("My Orders", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/account/settings",
                      class: "hover:text-white transition-colors"
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("Settings", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/cart",
                      class: "hover:text-white transition-colors"
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("My Cart", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "hover:text-white transition-colors"
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("Sign In", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/register",
                      class: "hover:text-white transition-colors"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Register", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/cart",
                      class: "hover:text-white transition-colors"
                    }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("My Cart", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ], 64))
          ])
        ]),
        _cache[15] || (_cache[15] = _createStaticVNode("<div><h3 class=\"text-white font-semibold text-sm mb-4 uppercase tracking-wide\">Contact</h3><ul class=\"space-y-2 text-sm\"><li class=\"flex items-start gap-2\"><svg class=\"w-4 h-4 mt-0.5 flex-shrink-0 text-accent-300\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 11a3 3 0 11-6 0 3 3 0 016 0z\"></path></svg><span>Kigali, Rwanda</span></li><li class=\"flex items-center gap-2\"><svg class=\"w-4 h-4 flex-shrink-0 text-accent-300\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z\"></path></svg><span>+250 700 000 000</span></li><li class=\"flex items-center gap-2\"><svg class=\"w-4 h-4 flex-shrink-0 text-accent-300\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z\"></path></svg><span>info@jengahills.com</span></li></ul></div>", 1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[17] || (_cache[17] = _createElementVNode("div", null, [
            _createElementVNode("p", { class: "text-white font-semibold mb-1" }, "Are you a supplier or contractor?"),
            _createElementVNode("p", { class: "text-secondary-400 text-sm" }, "Join Jenga Hills as a vendor and reach thousands of builders across Rwanda.")
          ], -1)),
          _createVNode(_component_router_link, {
            to: "/vendor/register",
            class: "flex-shrink-0 bg-accent-300 hover:bg-accent-400 text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode(" Start Selling ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", null, "© " + _toDisplayString(_ctx.year) + " Jenga Hills. All rights reserved.", 1),
        _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"flex items-center gap-4\"><a href=\"#\" aria-label=\"Facebook\" class=\"hover:text-white transition-colors\"><svg class=\"w-4 h-4\" fill=\"currentColor\" viewBox=\"0 0 24 24\"><path d=\"M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z\"></path></svg></a><a href=\"#\" aria-label=\"Twitter / X\" class=\"hover:text-white transition-colors\"><svg class=\"w-4 h-4\" fill=\"currentColor\" viewBox=\"0 0 24 24\"><path d=\"M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z\"></path></svg></a><a href=\"#\" aria-label=\"LinkedIn\" class=\"hover:text-white transition-colors\"><svg class=\"w-4 h-4\" fill=\"currentColor\" viewBox=\"0 0 24 24\"><path d=\"M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z\"></path></svg></a><a href=\"#\" aria-label=\"WhatsApp\" class=\"hover:text-white transition-colors\"><svg class=\"w-4 h-4\" fill=\"currentColor\" viewBox=\"0 0 24 24\"><path d=\"M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z\"></path></svg></a></div>", 1))
      ])
    ])
  ]))
}